/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit, ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material';
import {
  Response,
  SearchReposResponse,
} from '@octokit/rest';

@Component({
  selector: 'app-explorer',
  templateUrl: 'explorer.component.html',
  styleUrls: ['./explorer.component.scss'],
})
export class ExplorerComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  public paginator: MatPaginator;
  public searchEl = new FormControl();
  @Input()
  public repos: Response<SearchReposResponse>;
  @Input()
  public pageSize: number;
  @Output()
  public pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  public search: EventEmitter<string> = new EventEmitter<string>();

  public ngOnInit(): void {
    this.searchEl.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        this.search.emit(value);
        this.paginator.pageIndex = 0;
      });
  }
}
